module.exports = __webpack_public_path__ + "img/album07_08.7a55bc36.jpg";